import React, { useState, useEffect } from "react";

import {
  Card,
  Typography,
  Pagination,
  Table,
  message,
  Popconfirm,
  Button,
  Empty,
} from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";

import { useSelector } from "react-redux";
import BulkCoursesAdd from "../../../../components/AdminComponents/Modals/BulkCoursesAdd";
import axiosInstance from "../../../../api/Axios";
import {
  DeleteTwoTone,
  MenuOutlined,
  RetweetOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
const { Title } = Typography;
const Content = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [stepsMoved, setStepsMoved] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `learn/learningpathdetailslist/?learning_path_id=${id}`,
    loadAgain: loadAgain,
  });
  const SortableItem = ({ children, ...props }) => {
    const id = props["data-row-key"];
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id });

    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        }
      ),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 9999,
          }
        : {}),
    };

    return (
      <tr {...props} ref={setNodeRef} style={style} {...attributes}>
        {React.Children.map(children, (child) => {
          if (child.key === "sort") {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  style={{
                    touchAction: "none",
                    cursor: "move",
                    color: "blue",
                  }}
                  {...listeners}
                />
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: props,
      duration: 5,
    });
    LoadAPI();
  };
  const CreateFailed = (props, err) => {
    const messageApi = message;

    const errorMessage = err?.response?.data?.detail?.non_field_errors?.[0];

    messageApi.open({
      type: "error",
      content: errorMessage || props,
      duration: 5,
    });
  };
  const handleSubmit = async (values) => {
    try {
      await axiosInstance.put(`/learn/learningpathcoursesort/`, values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull("Step Order Updated");
    } catch (err) {
      CreateFailed("Step Order Update Failed", err);
    }
  };
  const onDragEnd = ({ active, over }) => {
    console.log(active, over);
    if (active.id !== over?.id) {
      setStepsMoved(true);
      setDataSource((previous) => {
        const activeIndex = previous.findIndex(
          (i) => i.content_id === active.id
        );
        const overIndex = previous.findIndex((i) => i.content_id === over?.id);
        return arrayMove(previous, activeIndex, overIndex);
      });
    } else {
      console.log("coming here");
    }
  };

  const stepSort = () => {
    const data = {
      learning_path_id: Number(id),
      course_orders: dataSource?.map((item, index) => ({
        course_id: item.child_course_id,
        order_index: index + 1,
      })),
    };

    console.log(data);
    handleSubmit(data);
    setStepsMoved(false);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Content has been Removed.",
      duration: 5,
    });
    props.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Content Remove Failed",
      duration: 5,
    });
  };

  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(
        `/learn/learningpathcoursedelete/${record?.learning_path_course_id}/${record?.child_course_id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const [dataSource, setDataSource] = useState(data || []);
  useEffect(() => {
    setDataSource(data);
  }, [data]);
  const columns = [
    ...(props?.ImpersonateAccess
      ? [{ title: "", key: "sort", width: 50, align: "center" }]
      : []),
    // {
    //   title: "Content ID",
    //   dataIndex: "course_id",
    //   key: "course_id",
    //   width: 140,
    // },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
    },
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
      width: 100,
      ellipsis: true,
    },
    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      width: 150,
    },
    {
      title: "Type",
      dataIndex: "course_type",
      key: "course_type",
      width: 150,
    },
    ...(props?.ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 150,
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Popconfirm
                  title={"Remove course?"}
                  description=" "
                  onConfirm={() => handleDelete(record)}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  <DeleteTwoTone
                    key="delete"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.6rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Content Summary
      </Title>
      <CommonTopDetails
        title={`Learning Path Content`}
        titleSuffix={`${itemsLength || 0} content(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
        customContent={
          <>
            {stepsMoved && (
              <>
                <Button
                  icon={<RetweetOutlined />}
                  onClick={() => {
                    setDataSource(data);
                    setStepsMoved(false);
                  }}
                >
                  Reset
                </Button>
                <Button icon={<SaveOutlined />} onClick={stepSort}>
                  Save Order
                </Button>
              </>
            )}
          </>
        }
      />
      {dataSource.length > 0 ? (
        <>
          <DndContext
            sensors={sensors}
            onDragEnd={onDragEnd}
            style={{ zIndex: dataSource.length === 0 ? 0 : 1 }}
          >
            <SortableContext
              items={dataSource.map((i) => i.content_id)}
              strategy={verticalListSortingStrategy}
            >
              <Table
                columns={columns}
                dataSource={dataSource}
                rowKey="content_id"
                size="small"
                loading={loading}
                className="table-container"
                style={{ margin: "1rem" }}
                pagination={false}
                scroll={{
                  x: 500,
                }}
                bordered
                locale={{ emptyText: "No Data Available" }}
                components={
                  props?.ImpersonateAccess && {
                    body: {
                      row: SortableItem,
                    },
                  }
                }
              />
            </SortableContext>
          </DndContext>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onPageChange}
              pageSizeOptions={["5", "10", "15", "20", "50"]}
              //   showQuickJumper
              current={currentPage}
              defaultPageSize={pageSize}
              total={itemsLength}
            />
          </div>
        </>
      ) : (
        <Empty />
      )}
      <BulkCoursesAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        bundle_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
        from={"path"}
      />
    </Card>
  );
};

export default Content;
